import palette from '../palette';

export default {
  root: {
    margin: '10px 0',
  },
  mark: {
    background: `${palette.success.main} !important`,
    height: '10px',
    width: '10px',
    borderRadius: '50%',
  },
  markActive: {
    background: `${palette.disabled.main} !important`,
    '&:first-child': {
      display: 'none',
    },
  },
  valueLabel: {
    color: `${palette.success.main} !important`,
    fontSize: '17px',
    top: '-30px',
    left: 'calc(50% - 16px)',
    width: '40px',
    height: '40px',
  },
  track: {
    background: `${palette.success.main} !important`,
    height: '10px',
    borderRadius: '10px',
  },
  rail: {
    background: `${palette.disabled.main} !important`,
    height: '10px',
    borderRadius: '10px',
  },
  thumb: {
    height: '18px',
    width: '18px',
    background: `${palette.success.main} !important`,
    '&:hover': {
      boxShadow: '0px 0px 0px 8px rgba(3, 203, 48, 0.18)',
    },
    '&:active': {
      boxShadow: '0px 0px 0px 14px rgba(3, 203, 48, 0.18)',
    },
  },
};